import React, { useState, useEffect } from 'react';
import { Card, Grid, Input, makeStyles, TextField, Typography } from '@material-ui/core';
import DateFnsUtils from "@date-io/date-fns";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";

const DateFilterButton = ({date, label, onChange}) => {

    const classes = useStyles()

    return ( 
        <Card className={classes.card}>
            <Grid container>
                <Grid item xs={12}>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                        <DatePicker
                            autoOk
                            label={label}
                            value={date}
                            onChange={onChange}
                            animateYearScrolling
                            TextFieldComponent={(props) => <TextField {...props} InputProps={{disableUnderline:true}}  />}
                        />
                    </MuiPickersUtilsProvider>
                </Grid>
            </Grid>
        </Card>
     );
}

const useStyles = makeStyles(theme => ({
    card:{
        boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
        padding:'8px 16px',
        paddingBottom:0,
        borderRadius:12,
        width:140
    },
    label:{
        fontSize:12
    }
}))
 
export default DateFilterButton;